import { render, staticRenderFns } from "./BottomCharts.vue?vue&type=template&id=3a92122a"
import script from "./BottomCharts.vue?vue&type=script&lang=js"
export * from "./BottomCharts.vue?vue&type=script&lang=js"
import style0 from "./BottomCharts.vue?vue&type=style&index=0&id=3a92122a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports